// extracted by mini-css-extract-plugin
module.exports = {"DisplayName":"AvatorWithName_DisplayName__mIT4n"};